import React, { useEffect, useState } from "react";
import StudentTopMenu from "./studenttopmenu";
import { useParams } from "react-router-dom";
import StudentInfoBox from "./studentinfobox";
import GlobalStudentLesson from "../../pages/common/globalstudentlessonforgrade";
import { useAuth } from "../../../usercontext";
import Student911TopMenu from "../studentInfo/student911topmenu"
import GlobalStudentLesson2 from "../../pages/common/globalstudentlesson2";
import { getIdData } from "../../../lib/studentinfo";
import Student12TopMenu from "../studentInfo/student12topmenu";
import GlobalStudentGpaRigorSummary from "../../pages/common/globalstudentgparigorsummary";
import GlobalStudentAverageGpaSummary from "../../pages/common/GlobalStudentAverageGpaSummary";
import GlobalStudentCalculatedGpaSummary from "../../pages/common/GlobalStudentCalculatedGpaSummary";
import GlobalStudentApScoreSummary from "../../pages/common/GlobalStudentApScoreSummary";
import GlobalStudentCourseLessonReport from "../../pages/common/globalstudentcourselessonreport";
import GlobalStudentCourseLessonAverageGpaReport from "../../pages/common/GlobalStudentCourseLessonAverageGpaReport";
import GlobalStudentCourseLessonLevelReport from "../../pages/common/globalstudentcourselessonlevelreport";
import GlobalStudentCourseLessonGradeYearReport from "../../pages/common/globalstudentcourselessongradeyearreport";
import GlobalStudentCourseLessonCalculatedGpaReport from "../../pages/common/GlobalStudentCourseLessonCalculatedGpaReport";

export default function InstructorStudentCoursesReport() {
  const { profile, setProfile } = useAuth();
    let { slug } = useParams();
    const [isStudent911, setisStudent911] = useState(false);
    const [isStudent12, setisStudent12] = useState(false);

      async function GetData() {
        const info = await getIdData(slug);
        if (info[0].role === "Student911") {
          setisStudent911(true);
        } else if (info[0].role === "Student12") {
          setisStudent12(true);
        }
      }
       
        useEffect(() => {
          GetData();
        }, []);

  return (
    <>
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
                {/* {isStudent911 && <Student911TopMenu slug={slug} activeMenu={"CoursesReports"} /> } */}
                {/* {isStudent12 && <Student12TopMenu slug={slug} activeMenu={"Lessons"} /> } */}
                <div className="card p-3">
                <h4 className="mb-3">GRADE LEVEL</h4>
                  <GlobalStudentCourseLessonLevelReport studentId={slug}/>
                  <GlobalStudentCourseLessonGradeYearReport studentId={slug}/>
                  <GlobalStudentApScoreSummary studentId={slug}/>
                </div>
                <div className="card p-3">
                <h4 className="mb-3">DEPARTMENTS</h4>
                  <GlobalStudentCourseLessonReport studentId={slug}/>
                  <GlobalStudentCourseLessonAverageGpaReport studentId={slug}/>
                  <GlobalStudentCourseLessonCalculatedGpaReport studentId={slug}/>
                </div>

                <div className="card p-3">
                <h4 className="mb-3">CURRENT AND FUTURE</h4>
                  <GlobalStudentGpaRigorSummary studentId={slug}/>
                  <GlobalStudentAverageGpaSummary studentId={slug}/>
                  <GlobalStudentCalculatedGpaSummary studentId={slug}/>
                </div>

            
           
            
            
          </div>
        </div>
      </div>
    </>
  );
}
